import * as React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { FaOptionIcon } from '@europrocurement/l2d-icons';

export interface AssistanceCardHeaderProps {
    onClose?: () => void;
}

export const AssistanceCardHeader: React.FunctionComponent<AssistanceCardHeaderProps> = function ({
    onClose,
}) {
    const theme = useTheme();

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                marginBottom: '16px',
            }}
        >
            <Typography
                variant="l2dh6"
                sx={{
                    color: theme.palette.secondary.main,
                    fontWeight: 600,
                    textAlign: 'left',
                }}
            >
                Nous contacter
            </Typography>
            <Box sx={{ flex: 1 }} />
            {onClose && (
                <Box
                    onClick={onClose}
                    sx={{
                        cursor: 'pointer',
                        color: theme.palette.grey[500],
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    <FaOptionIcon
                        icon="times"
                        size="lg"
                    />
                </Box>
            )}
        </Box>
    );
};
